import { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { UnitsTableHeader } from './unitsTableHeader';
import { StatusTags } from '../StatusTags';
import { formatSinceLastScore, formatTimestamp } from '../../utils/formatters';
import { getUnitProperty, isBackendUnit } from '../../schemas/unitSchema';

const getStatusColor = (statusColor) => {
  const colorMap = {
    green: '#28a745',
    yellow: '#ffc107',
    red: '#dc3545'
  };
  return colorMap[statusColor] || '#ccc';
};

const UnitRow = memo(({ unit, unitIssues, handleUnit }) => {
  const unitId = getUnitProperty(unit, 'unit');
  const hasErrors = getUnitProperty(unit, 'hasErrors', false);
  const sinceLastScore = getUnitProperty(unit, 'since_last_score', '-');
  const lastLoginTimestamp = getUnitProperty(unit, 'lastLoginTimestamp');
  const dailyUnitUse = getUnitProperty(unit, 'daily_unit_use', '-');
  const totalKpodUse = getUnitProperty(unit, 'total_kpod_use', '-');
  const statusColor = getUnitProperty(unit, 'statusColor');
  const isSit = getUnitProperty(unit, 'isSit', false);
  const organization = getUnitProperty(unit, 'organization', '');

  return (
    <tr onClick={() => handleUnit(unit)} style={{ cursor: 'pointer' }}>
      <td className='text-start'>
        {unitId} {isSit && "[S] "}
        {!isBackendUnit(unit) && organization}
        {hasErrors && (
          <span style={{ color: "#FAC63E" }}>
            {" "}<FontAwesomeIcon icon={faInfoCircle} style={{ color: '#CBCBCB' }}/>
          </span>
        )}
      </td>
      <td style={{ whiteSpace: 'normal', verticalAlign: 'middle' }}>
        <StatusTags
          selectedUnitItem={unit}
          unitIssues={unitIssues}
        />
      </td>
      <td>
        {sinceLastScore === "-"
          ? sinceLastScore
          : formatSinceLastScore(sinceLastScore)}
      </td>
      <td>
        {lastLoginTimestamp
          ? formatTimestamp(lastLoginTimestamp)
          : '-'}
      </td>
      <td>{dailyUnitUse}</td>
      <td className="mobile-hidden">{totalKpodUse}</td>
      <td className="mobile-hidden">{"XXd"}</td>
      <td className="mobile-hidden" style={{ textAlign: "center", verticalAlign: "middle" }}>
        <span
          style={{
            display: "inline-block",
            width: "14px",
            height: "14px",
            borderRadius: "50%",
            backgroundColor: getStatusColor(statusColor)
          }}
        />
      </td>
    </tr>
  );
});

const UnitsTable = ({
  units,
  handleSort,
  handleUnit,
  classifiedIssuesbyUnitAndKey
}) => {
  return (
    <div className="table-wrapper pb-0">
      <table className="table table-striped table-hover">
        <colgroup>
          <col style={{ width: "18%" }}/>
          <col style={{ width: "30%" }}/>{/* Status tags */}
          <col style={{ width: "8%" }}/>
          <col style={{ width: "12%" }}/>{/* LAST LOGIN */}
          <col style={{ width: "8%" }}/>
          <col style={{ width: "8%" }} className="mobile-hidden"/>
          <col style={{ width: "8%" }} className="mobile-hidden"/>
          <col style={{ width: "8%" }} className="mobile-hidden"/>
        </colgroup>
        <UnitsTableHeader handleSort={handleSort} />
        <tbody>
          {units.map((unit) => {
            const unitId = getUnitProperty(unit, 'unit');
            const unitIssues = classifiedIssuesbyUnitAndKey[unitId] ?? null;
            return (
              <UnitRow
                key={unitId}
                unit={unit}
                unitIssues={unitIssues}
                handleUnit={handleUnit}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default UnitsTable;